/**
 * @file 工具
 * @author yangwei(yangwei14@baidu.com)
 */

import _ from 'lodash';
import codeMap from '../client/code-map';

export const addEvent = (obj, type, fn) => {
    if (obj.attachEvent) {
        obj.attachEvent('on' + type, function () {
            fn.call(obj);
        });
    } else {
        obj.addEventListener(type, fn, false);
    }
};

/**
 * 解析resposne中的错误
 *
 * @param {Object} error reposne
 * @return {Objrct} 错误对象
 */
export const matchError
    = error => (_.find(codeMap, tag => tag.code === Number(error.code)) || {messgae: codeMap.UNKNOWN.message});
